module.exports = __webpack_public_path__ + "img/aboutBg.0bfb2ec8.jpg";